<template>
  <b-modal :active.sync="opened" :full-screen="isFullScreen" width="500px">
    <div class="card">
      <div class="card-content">
        <div class="section-block">
          <span class="title is-uppercase">Onboard New Student</span>
        </div>

        <validation-observer
          ref="form"
          @submit.prevent="submit"
          tag="form"
          v-slot="{ valid }"
        >
          <validation-provider
            vid="first_name"
            name="first name"
            rules="required"
            v-slot="{ errors }"
          >
            <b-field :message="errors" :type="{ 'is-danger': errors.length }">
              <b-input
                v-model="form.first_name"
                placeholder="First Name"
              ></b-input>
            </b-field>
          </validation-provider>

          <validation-provider
            vid="last_name"
            name="last name"
            rules="required"
            v-slot="{ errors }"
          >
            <b-field :message="errors" :type="{ 'is-danger': errors.length }">
              <b-input
                v-model="form.last_name"
                placeholder="Last Name"
              ></b-input>
            </b-field>
          </validation-provider>

          <validation-provider
            name="email"
            rules="required|email"
            v-slot="{ errors }"
          >
            <b-field :message="errors" :type="{ 'is-danger': errors.length }">
              <b-input
                v-model="form.email"
                placeholder="Email Address"
                type="email"
              ></b-input>
            </b-field>
          </validation-provider>

          <div class="level">
            <div class="level-left"></div>
            <div class="level-right">
              <b-button
                :disabled="!valid || isSubmitting"
                :loading="isSubmitting"
                native-type="submit"
                type="is-primary"
                >Invite to Group</b-button
              >
            </div>
          </div>
        </validation-observer>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
import Member from '@/models/Member'
import ModalMixin from '@/utils/mixins/modal'

export default {
  mixins: [ModalMixin],
  data() {
    return {
      opened: false,
      isSubmitting: false,
      form: {
        first_name: '',
        last_name: '',
        email: ''
      }
    }
  },
  computed: {
    ...mapState({
      group: state => state.group.currentGroup
    })
  },
  methods: {
    open() {
      this.opened = true
    },
    close() {
      this.opened = false
    },
    submit() {
      this.isSubmitting = true
      const member = new Member(this.form).for(this.group)
      member
        .save()
        .then(member => {
          this.form = {
            first_name: '',
            last_name: '',
            email: ''
          }
          this.$buefy.snackbar.open({
            message: `An invitation was sent to ${member.first_name} ${member.last_name}`,
            position: 'is-top',
            type: 'is-success'
          })
          this.$emit('added', member)
          this.close()
        })
        .catch(({ response }) => {
          if (response.data && response.data.errors) {
            this.$refs.form.setErrors(response.data.errors)
          }
        })
        .then(() => {
          this.isSubmitting = false
        })
    }
  }
}
</script>
